module.exports = __webpack_public_path__ + "img/placeholder.b1c3982e.svg";